/**
 * UUID Generation Utility
 *
 * Simple UUID v4 generator for run IDs.
 *
 * @packageDocumentation
 */

/**
 * Generates a UUID v4 string.
 *
 * @returns UUID v4 string
 *
 * @example
 * ```typescript
 * const id = generateUUID();
 * // Returns: "550e8400-e29b-41d4-a716-446655440000"
 * ```
 */
export function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Generates a prefixed run ID.
 *
 * @param prefix - Prefix for the ID (default: "run")
 * @returns Prefixed ID string
 *
 * @example
 * ```typescript
 * const runId = generateRunId();
 * // Returns: "run_550e8400-e29b-41d4-a716-446655440000"
 * ```
 */
export function generateRunId(prefix: string = 'run'): string {
  return `${prefix}_${generateUUID()}`;
}
